import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Common from "../common";
import { API_URL } from "../app/index";

export default function Modal() {
  const [errorMsg, setErrorMsg] = useState("");
  const [email, setEmail] = useState("");
  const [wallet, setWalletAddress] = useState("");
  const [walletError, setWalletError] = useState("");
  const [is_loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const checkIfEmptyFields = () => {
    if (!wallet) {
      setWalletError("Wallet Address is required...");
      return true;
    }
    return false;
  };

  const handleChange = (e) => {
    if (walletError && e.target.value) setWalletError("");
    if (errorMsg) setErrorMsg("");
    setWalletAddress(e.target.value);
  };

  const handleEmailChange = (e) => {
    if (errorMsg) setErrorMsg("");
    setEmail(e.target.value);
  };

  const whitelist = (e) => {
    e.preventDefault();
    setLoading(true);

    const emptyFields = checkIfEmptyFields();

    if (!emptyFields) {
      const url = API_URL,
        body = {
          wallet_address: wallet,
        };

      if (email) body.email = email;

      axios
        .post(url + "whitelist/create", body)
        .then((response) => {
          Common.googleAnalyticsEvent("Conversion", "White Listed");

          setEmail("");
          setWalletAddress("");
          setLoading(false);

          window.$("#whitelistModal").modal("hide");
          localStorage.setItem("connectedCheck", true);
          navigate("/wlconfirm");
        })
        .catch((error) => {
          setErrorMsg(error.response.data.message);
          setLoading(false);
        });
    } else setLoading(false);
  };

  const resetFields = () => {
    setEmail("");
    setWalletAddress("");
    setWalletError("");
    setErrorMsg("");
    setLoading(false);
  };

  return (
    <div
      className="modal fade"
      id="whitelistModal"
      tabIndex="-1"
      role="dialog"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      aria-labelledby="whitelistModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog custom-modal modal-dialog-centered">
        <div className="modal-content dark">
          <div className="modal-header text-center">
            <h1 className="modal-title" id="whitelistModalLabel">
              Join Whitelist
            </h1>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={() => resetFields()}
            ></button>
          </div>
          <div className="modal-body">
            {errorMsg && (
              <div className="text-center error-txt">
                <p>{errorMsg}</p>
              </div>
            )}
            <form onSubmit={(e) => whitelist(e)}>
              <div className="form-group">
                <label htmlFor="">
                  Your ETH Wallet Address<span className="error-txt">*</span>
                </label>
                <input
                  type="text"
                  className={`form-control ${walletError ? "has-error" : ""}`}
                  id="wallet"
                  value={wallet}
                  onChange={(e) => handleChange(e)}
                />
                {walletError && (
                  <div className="error-txt">
                    <p className="mb--0">{walletError}</p>
                  </div>
                )}
              </div>
              <div className="form-group">
                <label htmlFor="">Your Email Address</label>
                <input
                  type="email"
                  className={`form-control`}
                  id="email"
                  value={email}
                  onChange={(e) => handleEmailChange(e)}
                />
              </div>
              <div className="text-center pt--15 pb--15">
                <button
                  type="submit"
                  className="btn btn-primary --custom-btn lg submit-btn"
                  disabled={is_loading}
                >
                  <span>{is_loading ? "Loading..." : "Submit Now"}</span>
                </button>
              </div>
            </form>
          </div>
          <div className="modal-footer"></div>
        </div>
      </div>
    </div>
  );
}
